import React, { useState } from 'react'
import { PDFDocument, rgb } from "pdf-lib";
import Header from './Header'
import { useNavigate, useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import axios from "axios";
import Swal from 'sweetalert2'
import ReactLoading from 'react-loading';
import config from "../../config"
import Moment from 'react-moment';
import TablePagination from '@mui/material/TablePagination';
import { useNetworkState } from 'react-use';
import Footer from './Footer';
import moment from 'moment'
import $ from 'jquery';
import 'daterangepicker/daterangepicker.css'; // Import daterangepicker CSS
import 'daterangepicker';

const International_action_2 = () => {
  const shipment_id = useParams();
  console.log("shipment_id == ", shipment_id)
  const [state, setState] = React.useState([])
  const [hubstate, sethubState] = React.useState([])
  const [loader, setloader] = React.useState(false)

  let userDetail = localStorage.getItem('ship_rocket_user');
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail)
  }
  React.useEffect(() => {
    shipment_tracking()
    dropHub()
  }, [])
  const shipment_tracking = () => {

    let full_api = config.apiUrl + `/shipment/shipment_detail`;
    let sendData = { customer_id: userData.customer_id, shipment_id: shipment_id.shipment_id };
    // console.log("sendData",sendData)

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      if (res.data.status == 200) {
        setState(res.data.output)
      }
      else {

      }


    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }

  const dropHub = () => {

    let full_api = config.apiUrl + `/shipment/available_drop_hub`;
    let sendData = { customer_id: userData.customer_id, shipment_id: shipment_id.shipment_id };
    // console.log("sendData",sendData)

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      if (res.data.status == true) {
        sethubState(res.data.output)
      }
      else {

      }


    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }

  const shipping_label = async (wbn) => {
    try {
      setloader(true)
      let full_api = config.apiUrl + `/shipment/download_label`;
      let sendData = { wbn: wbn }
      const response = await axios.post(full_api, sendData, { headers: config.headers }, { responseType: "blob" })
      const response_pdf = response.data.packages[0].pdf_download_link
      console.log("response_pdf===", response_pdf)
      if (response_pdf) {
        setloader(false)
        // Open PDF in a new tab
        window.open(response_pdf, "_blank");

        // OR force download
        // const link = document.createElement("a");
        // link.href = response_pdf;
        // link.setAttribute("download", `Delhivery_Label_${wbn}.pdf`);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
      } else {
        setloader(false)
        console.error("PDF URL not found in response.");
      }
    } catch (error) {
      setloader(false)
      console.error("Error downloading the label:", error);
    }
  };

  const downloadKycDocuments = async () => {
    const files = [];
    if (state[0]?.shipper_kyc_document_1) {
      files.push(state[0].shipper_kyc_document_1);
    }
    if (state[0]?.shipper_kyc_document_2) {
      files.push(state[0].shipper_kyc_document_2);
    }


    if (files.length === 0) {
      alert("No KYC document available");
      return;
    }

    try {
      console.log("Fetching images from:", files);

      const pdfDoc = await PDFDocument.create();

      for (const fileUrl of files) {
        console.log("Fetching:", fileUrl);
        const response = await fetch(fileUrl);

        if (!response.ok) {
          console.error("Failed to fetch:", fileUrl);
          alert("Error fetching image: " + fileUrl);
          return;
        }

        const imageBytes = await response.arrayBuffer();
        console.log("Image downloaded successfully:", fileUrl);

        let image;
        try {
          image = await pdfDoc.embedJpg(imageBytes);
        } catch (jpgError) {
          console.warn("JPG failed, trying PNG:", jpgError);
          image = await pdfDoc.embedPng(imageBytes);
        }

        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Sender_KYC_Documents.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error creating PDF:", error);
      alert("Failed to generate PDF.");
    }
  };


  const downloadKycReceiverDocuments = async () => {
    const files = [];
    if (state[0]?.consignee_kyc_document_1) {
      files.push(state[0].consignee_kyc_document_1);
    }
    if (state[0]?.consignee_kyc_document_2) {
      files.push(state[0].consignee_kyc_document_2);
    }


    if (files.length === 0) {
      // alert("No KYC document available");
      return;
    }

    try {
      console.log("Fetching images from:", files);

      const pdfDoc = await PDFDocument.create();

      for (const fileUrl of files) {
        console.log("Fetching:", fileUrl);
        const response = await fetch(fileUrl);

        if (!response.ok) {
          console.error("Failed to fetch:", fileUrl);
          alert("Error fetching image: " + fileUrl);
          return;
        }

        const imageBytes = await response.arrayBuffer();
        console.log("Image downloaded successfully:", fileUrl);

        let image;
        try {
          image = await pdfDoc.embedJpg(imageBytes);
        } catch (jpgError) {
          console.warn("JPG failed, trying PNG:", jpgError);
          image = await pdfDoc.embedPng(imageBytes);
        }

        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Receiver_KYC_Documents.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error creating PDF:", error);
      alert("Failed to generate PDF.");
    }
  };
  const openPdf = (pdf) => {
    let pdfWindow = window.open("")
    pdfWindow.document.write(
      "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
      encodeURI(pdf) + "'></iframe>"
    )
  }
  return (
    <div>
      <Header />
      <div class="page-wrapper pinned">
        <div class="main-container">
          <div className='app-container'>
            <div class="app-body">

              <div class="mob_nav">
                <div class=" d-flex justify-content-start ">
                  <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
                  <h2>{state.length > 0 ? state[0].carrier_tracking_number : ""}</h2>
                </div>
              </div>


              <div class="row justify-content-between">
                <div class="col-12 col-md-4 desk_nav">
                  <div class="d-flex">
                    <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                    <h2>{state.length > 0 ? state[0].carrier_tracking_number : ""}</h2>
                  </div>
                </div>
              </div>



              <div class="row justify-content-center">
                {state.length > 0 ?
                  <>
                    {state[0].int_action == "Self Ship" ?
                      <div class="col-12 col-md-6">
                        <div class="card border-0 mb-3">
                          <div class="card-body">
                            <div class="alert alert-success">
                              <strong>Success!</strong> Your shipment is booked as <strong>Self Ship</strong> mode. Please use the below Hub address details o drop off your shipment. Please download the international shipping label and attach it to the shipment box.
                              <br />
                              Also recommended to print two copies of the invoice and KYC to include with the box.
                            </div>



                            <h4>Mode: <strong class="text-primary">Self Ship</strong></h4>

                            <div class="row mt-4">
                              <div class="col-12 col-md-12 mb-2">
                                <h6>Avaiable Drop Hub</h6>
                                <hr />
                                {hubstate.length > 0 ? <>
                                  {hubstate.map((item) => (
                                    <>
                                      <h6>Address</h6>
                                      <p>
                                        {item.hub_address} , {item.hub_city} , {item.hub_state} , {item.hub_pincode}
                                      </p>
                                      <h6>Mobile Number</h6>
                                      <p>
                                        {item.hub_mobile}
                                      </p>
                                      <h6>Email</h6>
                                      <p>
                                        {item.hub_email}
                                      </p>
                                    </>
                                  ))}
                                  <small>Note: Please use Hub details in case you need any support.</small>

                                </> : ""}
                                <p>

                                </p>
                              </div>
                              {/* <div class="col-6 col-md-6 mb-2">
                                {state[0].carrier_id == "1737462194" ? <a href={`${state[0].shipping_label}`} class="btn btn-primary" target='_blank'><i class="bi bi-download"></i> Download International Label</a> : state[0].carrier_id == "1746785218" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" target='_blank'><i class="bi bi-download"></i> Download International Label</button> : state[0].carrier_id == "1747222584" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" ><i class="bi bi-download"></i> Download International Label</button> : state[0].carrier_id == "1746708024" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" ><i class="bi bi-download"></i> Download International Label</button> : ""}
                              </div> */}
                              {/* <div class="col-6 col-md-6 mb-2">
   {state[0].shipper_kyc_document_1!="" ||state[0].shipper_kyc_document_2!="" ?         <a className="btn btn-primary" onClick={downloadKycDocuments}> <i className="bi bi-download"></i> Download Sender KYC</a>:""}
           </div>
           <div class="col-6 col-md-6 mb-2">
           {state[0].consignee_kyc_document_1!="" ||state[0].consignee_kyc_document_1!="" ?   <a onClick={downloadKycReceiverDocuments} class="btn btn-primary"><i class="bi bi-download"></i> Download Receiver KYC</a>:""}
           </div> */}
                            </div>


                          </div>
                        </div>
                      </div>

                      :

                      state.length > 0 ?
                        <div class="col-12 col-md-6">
                          <div class="card border-0 mb-3">
                            <div class="card-body">
                              {state[0].int_action_process == 0 ?
                                <div class="alert alert-warning">
                                  <strong>Processing!</strong> Shipment is under creation. Please wait.
                                </div>
                                : state[0].int_action_process == 2 ?
                                  <div class="alert alert-danger">
                                    <strong>Error!</strong> Something went wrong. Please contact our support team for futher help.
                                  </div>
                                  :
                                  <div class="alert alert-success">
                                    <strong>Success!</strong> Your shipment is booked with door pickup. The AWB number is <strong>{state[0].local_awb}.</strong> Please download both the pickup and international shipping labels and attach them to the shipment box. The shipment will be picked up soon from your doorstep.<br />
                                    Also recommended to print two copies of the invoice and KYC to include with the box.
                                  </div>

                              }

                              <div class="row mt-4">
                                <div class="col-6 col-md-4 mb-2">
                                  <small class="text-muted">Order on</small>
                                  <p><a href=""><Moment format="MMM DD YYYY">
                                    {new Date(state[0].created * 1000)}
                                  </Moment> - <Moment format="hh:mm:ss a">
                                      {new Date(state[0].created * 1000)}
                                    </Moment></a></p>
                                </div>
                                <div class="col-6 col-md-4 mb-2">
                                  <small class="text-muted">Shipping Courier</small>
                                  <p>Delhivery</p>
                                </div>
                                <div class="col-6 col-md-4 mb-2">
                                  <small class="text-muted">Shipping Courier AWB No.</small>
                                  <p><a href="">{state[0].local_awb}</a></p>
                                </div>
                                {/* <div class="col-6 col-md-6 mb-2">
                 {loader == false?     <a onClick={(e)=>shipping_label(state[0].local_awb)} class="btn btn-primary"><i class="bi bi-download"></i> Download Pickup Label</a>:<ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} />}
                  </div>
                  <div class="col-6 col-md-6 mb-2">
                      <a href={`${state[0].shipping_label}`} target='_blank' class="btn btn-primary"><i class="bi bi-download"></i> Download International Label</a>
                  </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        : ""
                    }</> : ""}

              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

    </div>
  )
}

export default International_action_2
